<template>
  <div class="ts-relative ts-w-full overflow-auto" style="max-height: 600px;">
    <div class="container" v-if="resources.length">
      <div class="wrapper" style="width: 600px;">
        <ul class="sessions">
          <li v-for="(r, index) in resources" :key="index">
            <div class="ts-text-lg ts-text-blue-800">
              {{ r.created_date }}
            </div>
            <div class="ts-w-full">
              <div class="ts-flex ts-space-x-2 ts-items-center">
                <Icon type="ios-contacts" size="25" class="ts-text-gray-600" />
                <p
                  class="ts-mb-0 ts-font-heading-font ts-font-semibold ts-text-gray-600"
                >
                  {{ r.created_by_name }}
                </p>
              </div>
              <div
                class="ts-mb-0 ts-text-base ts-w-full"
                v-html="r.description"
              ></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="ts-w-full ts-h-full ts-flex ts-items-center ts-justify-center"
      v-if="!resources.length"
    >
      <img
        src="@/assets/no_data.png"
        class="ts-h-48 ts-object-contain"
        alt=""
      />
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
export default {
  props: ['resources'],
  data() {
    return {
      loading: false
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
ul,
li {
  list-style: none;
  padding: 0;
}

.container {
  display: flex;
  align-items: center;
}
.sessions {
  margin-top: 2rem;
  border-radius: 12px;
  position: relative;
}
li {
  padding-bottom: 1.5rem;
  border-left: 1px solid #211f6e;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;
  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }
  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: white;
    border: 1px solid #4e5ed3;
    box-shadow: 3px 3px 0px #bab5f8;
    box-shadow: 3px 3px 0px #bab5f8;
    border-radius: 50%;
    position: absolute;
    left: -10px;
    top: 0px;
  }
}
</style>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
